import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import config from '../functions/config';
import { Link,Navigate,useNavigate } from "react-router-dom";


const ChangePassword = () => {
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [error, setError] = useState('');
  const sessionId = Cookies.get('sessionid');
  const navigate = useNavigate(); // ✅ Use `useNavigate` correctly
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const validatePassword = (password) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharRegex.test(password);
  };

  useEffect(() => {
    if (formData.new_password && formData.confirm_password) {
      if (!validatePassword(formData.new_password)) {
        setError('Password must contain at least one special character');
      } else if (formData.new_password !== formData.confirm_password) {
        setError('Passwords do not match');
      } else {
        setError('');
      }
    }
  }, [formData.new_password, formData.confirm_password]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!sessionId) {
      alert('Session ID is missing. Please log in again.');
      return;
    }
    if (error) {
      alert(error);
      return;
    }
    try {
      const response = await fetch(`${config.BASE_URL}/api/change-password/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Session-ID': sessionId,
        },
        body: JSON.stringify({
          current_password: formData.current_password,
          new_password: formData.new_password
        }),
      });

      if (response.ok) {
        alert('Password changed successfully!');
        setFormData({ current_password: '', new_password: '', confirm_password: '' });

        setTimeout(() => {
          navigate('/login'); // ✅ Correct usage of `useNavigate`
        }, 2000);
      } else {
        const data = await response.json();
        alert(`Error: ${data.error}`);
      }
    } catch (err) {
      console.error('Error changing password:', err);
    }
  };

  return (
    <div>
         {/* Navbar */}
         <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        {/* Brand Name */}
        <Link className="navbar-brand" to="/">
          📚 Library 
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Menu */}
        <div className={`navbar-collapse ${isOpen ? "show" : "collapse"}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/success">
                Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/userhome">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile">
                Profile
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/rentalhistory">
                Rented Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/purchasehistory">
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/login" className="btn btn-danger">
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>


      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="card p-4 shadow" style={{ width: '400px' }}>
          <h2 className="text-center mb-4">Change Password</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="current_password" className="form-label">Current Password</label>
              <input type="password" id="current_password" name="current_password" value={formData.current_password} onChange={handleChange} className="form-control" required />
            </div>
            <div className="mb-3">
              <label htmlFor="new_password" className="form-label">New Password</label>
              <input type="password" id="new_password" name="new_password" value={formData.new_password} onChange={handleChange} className="form-control" required />
            </div>
            <div className="mb-3">
              <label htmlFor="confirm_password" className="form-label">Confirm Password</label>
              <input type="password" id="confirm_password" name="confirm_password" value={formData.confirm_password} onChange={handleChange} className="form-control" required />
              {error && <small className="text-danger">{error}</small>}
            </div>
            <button type="submit" className="btn btn-primary w-100" disabled={!!error}>Change Password</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
